import React, { useState, useCallback } from "react";
import Navigation from "../components/landing/Navigation";
import Intro from "../components/landing/Intro";
import About from "../components/landing/About";
import Services from "../components/landing/Services";
import Approach from "../components/landing/Approach";
import Testimonials from "../components/landing/Testimonials";
import Faq from "../components/landing/Faq";
import Footer from "../components/landing/Footer";
import BookingDialog from "../components/landing/BookingDialog";

export default function LandingPage() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [preselectedService, setPreselectedService] = useState(null);

  const openBooking = useCallback((serviceId = null) => {
    setPreselectedService(serviceId);
    setBookingOpen(true);
  }, []);

  return (
    <div className="oi-page">
      <Navigation onBook={openBooking} />
      <main>
        <Intro onBook={openBooking} />
        <Services onBook={openBooking} />
        <About />
        <Approach />
        <Testimonials />
        <Faq />
        <Footer />
      </main>
      <BookingDialog
        open={bookingOpen}
        onOpenChange={setBookingOpen}
        preselectedService={preselectedService}
      />
    </div>
  );
}
